<template>
  <div>
    <div
      class="modal fade"
      id="topicModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">
              <!-- {{ $t("information") }} -->
              {{ $t('topic') }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row col-sm-12">
              <div class="col-4" v-for="topic in topicList" :key="topic">
                <!-- {{ topic }} -->
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    :id="topic"
                    name="topicRadio"
                    class="custom-control-input"
                    :value="topic"
                    @click="updateSTopic(topic)"
                    v-model="mytop"
                  />
                  <label
                    class="custom-control-label"
                    :for="topic"
                    :value="topic"
                    >{{ topic }}</label
                  >
                </div>
              </div>
              <!--  -->
              <div class="col-4 mt-4">
                <!-- {{ topic }} -->

                <button class="btn btn-sm btn-secondary" @click="cancelRadio()">
                  <span class="">{{ $t('cancel-the-selection') }}</span>
                </button>
              </div>
              <!--  -->
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline btn-rounded"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-outline btn-rounded"
              data-dismiss="modal"
              @click="searchCourseResource()"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ApiSearchCourseResource } from "../http/apis/CourseDetail";
export default {
  name: "TopicModal",
  data() {
    return {
      topic: {
        id: "",
        title: "",
        content: "",
        isShow: false,
        isEdit: false,
        isDelete: false,
        isAdd: false,
      },
      mytop: "",
      courseid: this.$route.params.courseid,
    };
  },
  props: ["topicList", "selectTopic", "selectType"],
  watch: {
    selectTopic: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.mytop = newValue;
      },
    },
  },
  computed: {},
  methods: {
    updateSTopic(topic) {
      console.log("updateSTopic", topic);
      this.$emit("updateTopic", topic);
    },
    cancelRadio() {
      console.log("topmodal cancel radio");
      $("input[type=radio][name=topicRadio]").prop("checked", false);
      this.$emit("updateTopic", "");
    },
    // confirmTopic() {},
    async searchCourseResource() {
      //判斷是否有搜尋值
      let vm = this;
      let searchObj = {
        type: this.selectType,
        keyword: "",
        topic: this.selectTopic,
      };
      console.log("topic = ", searchObj);
      let result = await ApiSearchCourseResource.post(this.courseid, searchObj)
        .then((response) => {
          console.log(response);
          this.textbookList = response.record;

          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        this.$emit("getMList", this.textbookList);
        if (this.selectTopic !== "") {
          console.log("topic call addselectLevelList");
          this.$emit("addselectLevelList", "*");
        }
        return true;
      }
    },
  },
};
</script>
<style lang=""></style>
